import { Icons } from '@/components/Shares/Icons';
import type { TokenInfo } from '@/config/tokens';
import { Avatar, Button, Image, Menu } from '@mantine/core';
import classes from './Wallet.module.css';
export type TokenMenuDropdownProps = {
  logoURI: string | undefined;
  tokens: TokenInfo[];
  setActiveTab: (tab: string) => void;
};
export const TokenMenuDropdown: React.FC<TokenMenuDropdownProps> = ({
  logoURI,
  tokens,
  setActiveTab
}) => {
  return <Menu shadow="md" width={226} arrowSize={15} position="bottom-end" classNames={classes}>
      <Menu.Target>
        <Button px={0} variant="transparent" style={{
        pointerEvents: 'auto'
      }} classNames={{
        section: classes.section
      }} rightSection={<Icons className="icon-pr-line-chevron-down" fontSize={24} color="var(--text-dark)" />}>
          <Image src={logoURI} alt="token-logo" w={32} h={32} />
        </Button>
      </Menu.Target>

      <Menu.Dropdown style={{
      pointerEvents: 'auto'
    }}>
        {tokens.map(item => <Menu.Item key={item.symbol} leftSection={<Avatar src={item.logoURI} alt="token-logo" size={24} />} onClick={() => setActiveTab(item.symbol)}>
            {`${item.name} (${item.symbol})`}
          </Menu.Item>)}
      </Menu.Dropdown>
    </Menu>;
};